import React from "react";
import { EventInfo } from "../../shared/components";
import { humanizeNumber } from "../../../../lib/utils/numberFunctions";
import { truncate } from "../../../../lib/utils/stringFunctions";
import AnimatedContainer from "../../../../lib/utils/AnimatedContainer";
import Ticket from "./TicketItem";

export default class TicketSelection extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.decrementTickets = this.decrementTickets.bind(this);
    this.incrementTickets = this.incrementTickets.bind(this);
    this.setTickets = this.setTickets.bind(this);
  }

  toggleDescription(e) {
    e.preventDefault();
    this.setState({ showDesc: !this.state.showDesc });
  }

  calculateTotalTickets(tickets) {
    const ticketIds = Object.keys(tickets);

    if (ticketIds.length > 0) {
      return ticketIds.reduce((counter, id) => {
        if (tickets[id] && tickets[id].number) {
          return counter + tickets[id].number;
        }
        return counter;
      }, 0);
    } else {
      return 0;
    }
  }

  calculateTotalAmount(tickets) {
    const ticketIds = Object.keys(tickets);

    if (ticketIds.length > 0) {
      const total = ticketIds.reduce((counter, id) => {
        if (tickets[id] && tickets[id].number && tickets[id].amount) {
          return counter + tickets[id].number * tickets[id].amount;
        }
        return counter;
      }, 0);

      return total > 0 ? `$${total}` : "Free";
    } else {
      return 0;
    }
  }

  incrementTickets(ticketId) {
    const ticket = this.props.tickets[ticketId];
    const numberTickets = Number.parseInt(ticket.number) + 1;

    this.props.updateTicketState(ticketId, numberTickets);
  }

  decrementTickets(ticketId) {
    const ticket = this.props.tickets[ticketId];
    let numberTickets = Number.parseInt(ticket.number);

    if (numberTickets > 1) {
      numberTickets = numberTickets - 1;
    }

    this.props.updateTicketState(ticketId, numberTickets);
  }

  setTickets(ticketId, amount) {
    if (!event.target.value || event.target.value < 1) {
      this.props.updateTicketState(ticketId, 1);
    } else {
      this.props.updateTicketState(ticketId, Number.parseInt(event.target.value));
    }
  }

  render() {
    let header;

    const { selectedTickets, tickets, handleTransition, handleRemoveTicket } = this.props;

    if (this.props.event.registration_open) {
      header = (
        <div className="event-modal-top">
          <div className="percent-width-80">
            <h2 className="event-modal-header">Register for The Event</h2>
            <span className="event-modal-directions">
              Fill in the details in order to register to attend the event.
            </span>
          </div>
          <div className="percent-width-20">
            <div className="num-tickets-head-item primary-color-text">
              {this.calculateTotalTickets(this.props.tickets)}
            </div>
            <div className="num-tickets-head-title">Tickets</div>
          </div>
        </div>
      );
    } else {
      header = (
        <div className="event-modal-top">
          <h2 className="event-modal-header">registration is not currently open.</h2>
        </div>
      );
    }
    const ticketItems = selectedTickets.map((ticketId, key) => {
      const ticket = tickets[ticketId];

      return (
        <Ticket
          key={`${key}${ticketId}`}
          ticket={ticket}
          decrementTickets={this.decrementTickets.bind(this, ticketId)}
          incrementTickets={this.incrementTickets.bind(this, ticketId)}
          removeTicket={handleRemoveTicket}
          tickets={ticket.number}
        />
      );
    });

    if (ticketItems.length > 0) {
      ticketItems.push(
        <div key={"total"} className="f-1.5x text-right primary-color-text m-md-t">
          Total: {`${this.calculateTotalAmount(tickets)}`}
        </div>,
      );
    }

    if (this.calculateTotalTickets(tickets) > 0) {
      ticketItems.push(
        <div className="text-right" key={"btn"}>
          <button
            data-testid="t-TicketS-button"
            title="next"
            className="m-site-btn--primary"
            onClick={() => handleTransition("form")}>
            Next
          </button>
        </div>,
      );
    }
    return (
      <div className="event-modal">
        <div className="event-modal-background">
          {header}
          <div className="event-modal-body">
            <div className="event-modal-form">
              {this.props.event.registration_open ? (
                <div>
                  {ticketItems.length > 0 ? (
                    ticketItems
                  ) : (
                    <span>Select A Ticket to get started!</span>
                  )}
                </div>
              ) : (
                <p>Registration currently not open.</p>
              )}
            </div>
          </div>
          <div className="event-modal-bottom"></div>
        </div>
      </div>
    );
  }
}
